import React from 'react';
import { Link } from '../Link';
import { tc } from '../../lib/trackingContext';
import { useHomePageMiniNavLinks } from './useHomePageMiniNavLinks';

import './HomePageMiniNav.scss';

export const HomePageMiniNav: React.FC = () => {
  const flagValue = useHomePageMiniNavLinks();

  if (!flagValue) return null;

  return (
    <div className="HomePageMiniNav">
      <ul className="HomePageMiniNav__list">
        {flagValue.items.map(({ label, url }) => (
          <li className="HomePageMiniNav__item" key={`${label}:${url}`}>
            <Link
              className="HomePageMiniNav__link"
              to={url}
              onClick={() =>
                tc.track('Mini Nav Clicked', {
                  addToTrackingEvent: { type: label.toLowerCase() }
                })
              }
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
